export const itemdetails = [
	{
		id: 1,
		title: "Beef Tripe Noodle Soup | 牛百叶麻辣烫",
		category: "MaLaTang | 麻辣烫",
		price: 14.99,
		images: "./images/items/beef.png",
		description: "",
	},
	{
		id: 2,
		title: "Prince Mushroom Noodle Soup | 王子菇麻辣烫",
		category: "MaLaTang | 麻辣烫",
		price: 14.99,
		images: "./images/items/lamb.png",
		description: "",
	},
	{
		id: 3,
		title: "Fish Filet Noodle Soup | 鱼片麻辣烫",
		category: "MaLaTang | 麻辣烫",
		price: 14.99,
		images: "./images/items/shrimp ball.png",
		description: "",
	},
	{
		id: 4,
		title: "Luncheon Meat Stew | 午餐肉麻辣烫",
		category: "MaLaTang | 麻辣烫",
		price: 14.99,
		images: "./images/items/shrimp ball.png",
		description: "",
	},
	{
		id: 5,
		title: "Luncheon Meat Stew | 午餐肉麻辣烫",
		category: "MaLaTang | 麻辣烫",
		price: 14.99,
		images: "./images/items/shrimp ball.png",
		description: "",
	},
	{
		id: 6,
		title: "Cucumber Salad | 凉拌黄瓜",
		category: "Appetizers | 小吃",
		price: 10.99,
		images: "",
		description: "",
	},
	{
		id: 7,
		title: "Rice | 米饭",
		category: "Rice | 米饭",
		price: 2,
		images: "",
		description: "",
	},
	{
		id: 8,
		title: "Shredded Potato Salad | 凉拌土豆丝",
		category: "Appetizers | 小吃",
		price: 8.99,
		images: "",
		description: "",
	},
	{
		id: 9,
		title: "Shredded Potato Salad | 凉拌土豆丝",
		category: "Appetizers | 小吃",
		price: 8.99,
		images: "",
		description: "",
	},
	{
		id: 10,
		title: "Wang Zi Milk | 旺仔牛奶",
		category: "Beverages | 饮料",
		price: 8.99,
		images: "",
		description: "",
	},
	{
		id: 11,
		title: "Braised Tofu | 红烧豆腐",
		category: "Veggie Entrees",
		price: 16.99,
		images: "",
		description: "",
	},
	{
		id: 12,
		title: "Wang Zi Milk | 旺仔牛奶",
		category: "Beverages | 饮料",
		price: 8.99,
		images: "",
		description: "",
	},
	{
		id: 13,
		title: "Spicy Chicken in Dry Hot Pot | 辣子鸡",
		category: "Meat Entrees",
		price: 8.99,
		images: "",
		description: "",
	},
];
